/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — redirect-only: forwards /payment_status/:payment_id
 *              into `index` with payment_id folded into the query params
 *   extends:   Route
 *   template:  none
 *   model:     - (beforeModel transitions away before any model() would run)
 *   key:       beforeModel
 *   uses:      router service
 *   siblings:  -
 *   tests:     route-hooks-test.js
 *
 * Payment-provider return URL. Carries payment_id and any existing query
 * params over to `index`, which does the actual payment-status handling.
 */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class PaymentStatusRoute extends Route {
  @service router;

  beforeModel(transition) {
    const paymentId = transition.to.params.payment_id;
    const queryParams = transition.to.queryParams;

    this.router.transitionTo('index', {
      queryParams: {
        ...queryParams,
        payment_id: paymentId,
      },
    });
  }
}
